const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Modal = require("./Modal");
const Link = require("./Link");
const URLMake = require("../../../shared/URLMake");
const WonkyButton = require("./WonkyButton");
const Avatar = require("./Avatar");
const AssetsUtil = require("../util/AssetsUtil");
const {PortalDestination} = require("./PortalDestination");
const {Portal} = require("./Portal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const Copy = require("../util/CopyTable").forDemoTutorialModal();
const withVaultUpdate = require("../hoc/withVaultUpdate");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const AT = require("../../core/vault/ActionTypes");
const dbDemoData = require("../../../shared/data/dbDemoData.json");
const Analytics = require("../util/Analytics");

const styles = require("./styles/DemoTutorialModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component);
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "DemoTutorialModalView",

		propTypes: {
			modalTypeShown: PT.string.isRequired,

			// Injected by HOC
			dispatch: PT.func.isRequired,
		},

		closeModal: function() {
			this.props.dispatch({type: AT.CLOSE_DEMO_TUTORIAL});
		},

		exitTutorial: function() {
			this.closeModal();
			this.props.dispatch({type: AT.EXIT_DEMO_TUTORIAL});
		},

		showDemoEmailTutorial: function() {
			this.props.dispatch({type: AT.SHOW_DEMO_EMAIL_SIGN_UP_MODAL});
		},

		makeBody: function() {
			const textClass =
				this.props.modalTypeShown === "sellModal" ? styles.header : styles.text;
			return <div className={textClass}>{Copy[this.props.modalTypeShown]}</div>;
		},

		handleKeyPress: function(evt) {
			if (evt.which === 13) {
				this.closeModal();
			}
		},

		handleKeepPlaying: function() {
			Analytics.sendEvent(
				"Demo Interaction",
				"button click",
				"sell modal - keep playing button"
			);
			this.closeModal();
		},

		handleEmailSignup: function() {
			Analytics.sendEvent(
				"Demo Interaction",
				"button click",
				"sell modal - email signup button"
			);
			this.closeModal();
			this.showDemoEmailTutorial();
		},

		handleSubscription: function() {
			Analytics.sendEvent(
				"Demo Interaction",
				"button click",
				"sell modal - subscribe button"
			);
		},

		renderSellModalContents: function() {
			const sellModalCopy = Copy["sellModal"];

			return (
				<div className={styles.main}>
					<Modal
						onClose={this.closeModal}
						closeOnBackdropClick={false}
						closeOnEsc={true}
						backdropClass={styles.sellModalBackdrop}
						modalClass={styles.sellModalContent}
						levelType={"aboveAll"}
					>
						<img className={styles.bg} src={AssetsUtil.getModal("demo-box")} />
						<div className={styles.sellHeader}>{sellModalCopy.line1}</div>
						<div className={styles.sellText}>{sellModalCopy.line2}</div>
						<div className={styles.sellFinePrint}>{sellModalCopy.line3}</div>
						<div className={styles.subscriptionButton}>
							<Link
								to={URLMake.forEnroll()}
								useWonkyCursor={true}
								isNewTab={true}
								clickAction={this.handleSubscription}
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 171.2 83.82"
									width="171.2"
									height="83.82"
									preserveAspectRatio="none"
									className={styles.buttonImage}
								>
									<title>Demo_subscription_button</title>
									<path
										className={styles.sellButtonFrame}
										d="M0,5.64,7.45,81.21l158.69,2.61L171.2,0ZM155,71.19,12.29,74.51,7,12.62l154.81-1.93Z"
									/>
									<path
										className={styles.sellButtonBackground}
										d="M0,5.64,7.45,81.21l158.69,2.61L171.2,0Z"
									/>
								</svg>
								<div className={styles.sellButtonText}>
									{sellModalCopy.subscriptionButton}
								</div>
							</Link>
						</div>
						<div
							className={styles.keepPlayingButton}
							onClick={this.handleKeepPlaying}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 237.52 83.13"
								width="237.52"
								height="83.13"
								preserveAspectRatio="none"
								className={styles.buttonImage}
							>
								<title>Demo_keep_playing_button</title>
								<path
									className={styles.sellButtonFrame}
									d="M8,9.57,0,80.33l233.44,2.8L237.52,0ZM220.23,72.65l-206.89,2V15.84L226.11,8Z"
								/>
								<path
									className={styles.sellButtonBackground}
									d="M8,9.57,0,80.33l233.44,2.8L237.52,0Z"
								/>
							</svg>
							<div className={styles.sellButtonText}>
								{sellModalCopy.keepPlayingButton}
							</div>
						</div>
						<div
							className={styles.emailSignUpButton}
							onClick={this.handleEmailSignup}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 197.63 86.47"
								width="197.63"
								height="86.47"
								preserveAspectRatio="none"
								className={styles.buttonImage}
							>
								<title>Demo_join_email_button</title>
								<path
									className={styles.sellButtonFrame}
									d="M197.63,85.11,182.88,0,5.59,5.61,0,86.47Zm-8.27-11.5-178.29,5,2-67.73L174.23,8.54Z"
								/>
								<path
									className={styles.sellButtonBackground}
									d="M197.63,85.11,182.88,0,5.59,5.61,0,86.47Z"
								/>
							</svg>
							<div className={styles.sellButtonText}>
								{sellModalCopy.emailSignUpButton}
							</div>
						</div>
					</Modal>
				</div>
			);
		},

		renderModalContents: function(modalTypeShown) {
			if (modalTypeShown === "problemCorrect") {
				return (
					<div>
						{
							"Great job! You get immediate feedback on every problem. If you need help, we also have videos and book sections for most lessons. Give them a try! You can also click the "
						}
						<div className={styles.inlineModalIconContainer}>
							<img
								className={styles.inlineModalIcon}
								src={global.BASE_URL + "assets/images/icons/button-info.svg"}
							/>
						</div>
						{" icon to review the instructions."}
					</div>
				);
			} else if (modalTypeShown === "problemIncorrect") {
				return (
					<div>
						{
							"Don't worry! You get immediate feedback on every problem. For more help, we also have videos and book sections for most lessons. Give them a try! You can also click the"
						}
						<div className={styles.inlineModalIconContainer}>
							<img
								className={styles.inlineModalIcon}
								src={global.BASE_URL + "assets/images/icons/button-info.svg"}
							/>
						</div>
						{"icon to review the instructions."}
					</div>
				);
			} else if (modalTypeShown === "home2ndVisit") {
				return (
					<div>
						{
							"Welcome back to the Home screen. You can navigate using the buttons in the blue bar. You can also click the "
						}
						<div className={styles.inlineModalIconContainer}>
							{/* TODO(ENABLE_SIMPLIFY_NAVIGATION_PHASE): Demo unify experience */}
							<img
								className={styles.inlineModalIcon}
								src={global.BASE_URL + "assets/images/icons/button-help.svg"}
							/>
						</div>
						{" button for help, the "}
						<div className={styles.inlineModalIconContainer}>
							<img
								className={styles.inlineModalIcon}
								src={
									global.BASE_URL + "assets/images/icons/button-settings.svg"
								}
							/>
						</div>
						{" to adjust settings, or the "}
						<div className={styles.inlineModalIconContainer}>
							<Avatar
								hasSurround={true}
								className={styles.inlineModalIcon + " " + styles.avatar}
								avatar={dbDemoData.avatarModel}
							/>
						</div>
						{" to view reports of progress and activity in the Profile page."}
					</div>
				);
			} else if (modalTypeShown === "videoUnderConstruction") {
				return (
					<div>
						{
							"The BA Online Theater includes over 1,000 videos. Most lessons in BA Online include a video."
						}
						<br />
						<br />
						{
							"The video library for BA2 is not yet complete. This video will be available soon."
						}
					</div>
				);
			} else if (modalTypeShown === "exitingDemoTutorial") {
				return (
					<div>
						{
							"If you'd ever like to restart the tutorial, you can do so by clicking the "
						}
						<div className={styles.inlineModalIconContainer}>
							{/* TODO(ENABLE_SIMPLIFY_NAVIGATION_PHASE): Demo unify experience */}
							<img
								className={styles.inlineModalIcon}
								src={global.BASE_URL + "assets/images/icons/button-help.svg"}
							/>
						</div>
						{` in the top navigation bar, then clicking "Restart Tutorial"`}
					</div>
				);
			} else {
				return Copy[modalTypeShown];
			}
		},

		render: function() {
			const highlightPortal = (
				<PortalDestination
					name={PORTAL_CONTAINERS.DEMO_TUTORIAL_HIGHLIGHT}
					onClick={this.closeModal}
				/>
			);

			if (!this.props.modalTypeShown) {
				// render the portal destinations regardless of whether or not a modal
				// is open
				return (
					<Portal container={PORTAL_CONTAINERS.DEMO_TUTORIAL_MODAL}>
						{highlightPortal}
					</Portal>
				);
			}
			const {modalTypeShown} = this.props;
			let modalEl;

			let exitTutorialStyle = styles.exitTutorial;

			if (modalTypeShown === "sellModal") {
				modalEl = this.renderSellModalContents();
			} else {
				// Modal that allows items to "pop through" the backdrop if you place the gateway at the
				// sibling level of the other items you want to control using z-index
				let gotItButton, replayLessonButton, cancelButton;
				if (modalTypeShown === "replayLesson") {
					const replayLesson = () => {
						this.props.dispatch({
							type: AT.REPLAY_DEMO_BLOCK,
						});
					};

					replayLessonButton = (
						<WonkyButton
							className={styles.replayLessonButton}
							handleClick={replayLesson}
							buttonType="replaylesson"
							overrideTextClass={styles.replayButtonText}
						/>
					);
					cancelButton = (
						<WonkyButton
							className={styles.cancelButton}
							handleClick={this.closeModal}
							buttonType="replaycancel"
							overrideTextClass={styles.replayButtonText}
						/>
					);
				} else {
					gotItButton = (
						<WonkyButton
							className={styles.gotItButton}
							handleClick={this.closeModal}
							buttonType="gotit"
						/>
					);
				}

				const contents = this.renderModalContents(modalTypeShown);

				const arrowStyle = styles[modalTypeShown + "Arrow"];
				const arrow = _.includes(
					["replayLesson", "trophy", "videoUnderConstruction"],
					modalTypeShown
				) ? null : (
					<img
						className={arrowStyle}
						src={AssetsUtil.getModal("demo-highlight-arrow")}
					/>
				);

				let arrow2Style, arrow2;
				const dualArrowTypes = [
					"home2ndVisit",
					"problemCorrect",
					"problemIncorrect",
					"profile",
				];
				if (dualArrowTypes.includes(modalTypeShown)) {
					arrow2Style = styles[modalTypeShown + "Arrow2"];
				}
				// check for second arrow here
				if (arrow2Style)
					arrow2 = (
						<img
							className={arrow2Style}
							src={AssetsUtil.getModal("demo-highlight-arrow")}
						/>
					);

				if (modalTypeShown === "profile")
					exitTutorialStyle += " " + styles.onProfile;

				let textStyle = styles.text;
				if (
					modalTypeShown === "problemCorrect" ||
					modalTypeShown === "problemIncorrect" ||
					modalTypeShown === "home2ndVisit"
				)
					textStyle += " " + styles.withIcons;

				const noExitTutorial = [
					"exitingDemoTutorial",
					"videoUnderConstruction",
				];
				const exitButton = _.includes(
					noExitTutorial,
					this.props.modalTypeShown
				) ? null : (
					<div className={exitTutorialStyle} onClick={this.exitTutorial}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 559.09 189.81"
							preserveAspectRatio="none"
							className={styles.exitTutorialSvg}
						>
							<title>Demo_exit_tutorial_button</title>
							<path
								className={styles.exitButtonFrame}
								d="M541.11,7.57,13.12,0,0,189.81,559.09,177.4Zm-14.2,150.75L30.39,179.91,27.56,13.73l498.63,8.43Z"
							/>
							<path
								className={styles.exitButtonBackground}
								d="M545,10,3,200Zm-10,155L27,182,25,10l505,5Z"
							/>
						</svg>
						<div className={styles.exitTutorialText}>EXIT TUTORIAL</div>
					</div>
				);

				modalEl = (
					<div className={styles.main}>
						<div className={styles.backdrop} />
						{highlightPortal}
						<div className={styles[modalTypeShown]}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 403.94 197.92"
								preserveAspectRatio="none"
								className={styles.bg}
							>
								<path
									className={styles.bgBackdrop}
									d="M395,10m-8,160L17,192,17,12l365,6Z"
								/>
								<path
									className={styles.bgFrame}
									d="M390.94,7.89,9.48,0,0,197.92,403.94,185Zm-10.26,157.2L22,187.6,19.91,14.31l360.25,8.8Z"
								/>
							</svg>
							{arrow}
							{arrow2}
							<div className={textStyle}>{contents}</div>
							{gotItButton}
							{replayLessonButton}
							{cancelButton}
						</div>
						{exitButton}
					</div>
				);
			}

			return (
				<Portal container={PORTAL_CONTAINERS.DEMO_TUTORIAL_MODAL}>
					{modalEl}
				</Portal>
			);
		},
	})
);
